import { Axios } from '../api';
import { REGISTERS_API_URL } from '../constants';
import { useBusinessStore } from '../store';
import { type MappedConfigurationResponse } from '../types';

export class BusinessService {
    async fetchAndUpdate() {
        const response = await Axios.get<MappedConfigurationResponse>(
            REGISTERS_API_URL.REGISTER.CONFIGURATION,
        );

        const businessStore = useBusinessStore.getState() ?? {};

        businessStore.update({
            businessName: response.data.businessName,
            businessLogo: response.data.businessLogo,
            branchName: response.data.branchName,
            businessId: response.data.businessId,
            branchId: response.data.branchId,
            registerIndex: response.data.registerIndex,
            registerName: response.data.registerName,
        });
    }
}
